module.exports = __webpack_public_path__ + "static/media/005-Wechseln_ID_2.25ab0c8f.mp3";